import { render, staticRenderFns } from "./CartSidebar.vue?vue&type=template&id=4f531c14&scoped=true"
import script from "./CartSidebar.vue?vue&type=script&lang=js"
export * from "./CartSidebar.vue?vue&type=script&lang=js"
import style0 from "./CartSidebar.vue?vue&type=style&index=0&id=4f531c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f531c14",
  null
  
)

export default component.exports